// extracted by mini-css-extract-plugin
export var arrow = "ArticlePeopleListBlock-module--arrow--NdOqv";
export var left = "ArticlePeopleListBlock-module--left--5cGx-";
export var right = "ArticlePeopleListBlock-module--right--2WM_P";
export var peopleListContainer = "ArticlePeopleListBlock-module--peopleListContainer--1zqm8";
export var slider = "ArticlePeopleListBlock-module--slider--1_J2s";